/* eslint-disable no-mixed-spaces-and-tabs */
import { Controller/* , useFormContext */ } from 'react-hook-form';
import React, { useMemo } from 'react';
import dayjs from 'dayjs';

import './element.scss';
import DatePicker from '../../../date-picker/date-picker';


interface CustomDatePickerProps {
  formControl: any;
  fieldArrayName: string;
  name: string;
  label?: string;
  placeholder?: string;
  defaultValue?: any;
  required?: boolean;
  disabled?: boolean;
  hidden?: boolean;
  formType?: string;
  minDate?: any;
  maxDate?: any;
  format?: string;
  views?: Array<'year' | 'month' | 'day'>;
}

interface CustomDatePickerProps {
  formControl: any;
  name: string;
  label: string;
  fieldArrayName?: string;
  required?: boolean;
  position?: number;
  formType?: string;
  placeholder?: string;
  defaultValue?: any;
  is_future_dates_allowed?: boolean;
  is_past_dates_allowed?: boolean;
  typeOfField?: string;
  disabled?: boolean;
  min_date?: any;
  max_date?: any;
  views?: any;
}

const CustomDatePicker = React.memo<CustomDatePickerProps>((props) => {
  // const formContext = useFormContext();

  // Memoize field name to prevent unnecessary recalculations
  const fieldName = useMemo(() =>
    `${props.fieldArrayName}.${props.name}`,
    [props.fieldArrayName, props.name]
  );

  // Memoize date calculations to prevent recalculation on every render
  const { minDate, maxDate } = useMemo(() => {
    const min = dayjs(props.min_date || null).isValid()
      ? dayjs(props.min_date)
      : null;

    const max = dayjs(props.max_date || null).isValid()
      ? dayjs(props.max_date)
      : null;

    return { minDate: min, maxDate: max };
  }, [props.min_date, props.max_date]);

  // Memoize required prop calculation
  const isRequired = useMemo(() =>
    props.formType === 'builder' ? false : props.required,
    [props.formType, props.required]
  );

  return (
    <Controller
      control={props.formControl}
      name={fieldName}
      render={({ field, fieldState }) => (
        <DatePicker
          {...field}
          {...props}
          dataPosition={props.position}
          dataName={fieldName}
          label={props.label}
          placeholder={props.placeholder}
          required={isRequired}
          defaultValue={props.defaultValue}
          disableFutureDates={props.is_future_dates_allowed}
          disablePastDates={props.is_past_dates_allowed}
          helperText={fieldState.error?.message}
          error={Boolean(fieldState.error)}
          disabled={props.disabled}
          minDate={minDate}
          maxDate={maxDate}
        />
      )}
    />
  );
});

CustomDatePicker.displayName = 'CustomDatePicker';
export { CustomDatePicker };
export default CustomDatePicker;
